const { SINGLE_PAGE, LISTING_PAGE } = require('./constants');
let activePageType, activeCollectionId;

(function() {
  const { pageType, currentCollectionId } = Hubs.appInstance;

  switch (pageType) {
    case 'item':
      activePageType = SINGLE_PAGE;
      break;
    default:
      activePageType = LISTING_PAGE;
  }

  activeCollectionId = currentCollectionId;
  
}());

module.exports = { activePageType, activeCollectionId };


// WEBPACK FOOTER //
// ./modules/handlePageType.js